import Entity from '../../../../core/domain/entity';
import UniqueEntityID from '../../../../core/domain/unique_entity_id';

export interface CachedMessage {
  message: string | undefined;
  conversationId: string;
}

export interface CacheProps {
  dietitianId: string;
  patientId: string;
  cachedMessages: CachedMessage[] | undefined;
}

export class CacheId extends Entity<unknown> {
  private constructor(id?: UniqueEntityID) {
    super(null, id);
  }

  public static create(id?: UniqueEntityID): CacheId {
    return new CacheId(id);
  }
}

export class Cache extends Entity<CacheProps> {
  get cacheId(): CacheId {
    return CacheId.create(this.id);
  }

  get dietitianId() {
    return this.props.dietitianId;
  }

  get patientId(): string {
    return this.props.patientId;
  }

  get cachedMessages(): CachedMessage[] | undefined {
    return this.props.cachedMessages;
  }

  set cachedMessages(value: CachedMessage[] | undefined) {
    this.props.cachedMessages = value;
  }

  private constructor(props: CacheProps, id?: UniqueEntityID) {
    super(props, id);
  }

  copyWith(props: CacheProps): Cache {
    return Cache.create(
      {
        ...this.props,
        ...props,
      },
      this.id,
    );
  }

  public static create(props: CacheProps, id?: UniqueEntityID): Cache {
    return new Cache(props, id);
  }
}
